import { lumi } from '@/lib/lumi'
import { useCallback, useState } from 'react'

export interface Book {
  _id: string
  title: string
  author: string
  description?: string
  price: number
  currency?: 'CHF' | 'EUR' | 'USD'
  coverUrl?: string
  purchaseUrl?: string
  isbn?: string
  stock?: number
  status: 'available' | 'sold_out' | 'hidden'
  order?: number
  creator: string
  createdAt: string
  updatedAt: string
}

export function useBooks() {
  const [books, setBooks] = useState<Book[]>([])
  const [loading, setLoading] = useState(false)

  const fetchBooks = useCallback(async (onlyVisible = false) => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.books.list({
        filter: onlyVisible ? { status: { $ne: 'hidden' } } : {},
        sort: { order: 1, createdAt: -1 },
      })
      setBooks(list as Book[])
    } catch (error) {
      console.error('Échec du chargement des livres:', error)
    } finally {
      setLoading(false)
    }
  }, [])

  const createBook = useCallback(async (data: Partial<Book>) => {
    const now = new Date().toISOString()
    const created = await lumi.entities.books.create({
      ...data,
      createdAt: now,
      updatedAt: now,
    })
    return created
  }, [])

  const updateBook = useCallback(async (id: string, data: Partial<Book>) => {
    const updated = await lumi.entities.books.update(id, {
      ...data,
      updatedAt: new Date().toISOString(),
    })
    return updated
  }, [])

  const deleteBook = useCallback(async (id: string) => {
    await lumi.entities.books.delete(id)
  }, [])

  return {
    books,
    loading,
    fetchBooks,
    createBook,
    updateBook,
    deleteBook,
  }
}
